__turbopack_context__.v({
  "aiIcon": "TUMdYG_aiIcon",
  "arrow": "TUMdYG_arrow",
  "icon": "TUMdYG_icon",
  "list": "TUMdYG_list",
  "root": "TUMdYG_root",
  "row": "TUMdYG_row",
  "text": "TUMdYG_text",
});
